import { render } from "./MiniGz.vue?vue&type=template&id=04322d2c&scoped=true"
import script from "./MiniGz.vue?vue&type=script&lang=js"
export * from "./MiniGz.vue?vue&type=script&lang=js"

import "./MiniGz.vue?vue&type=style&index=0&id=04322d2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04322d2c"]])

export default __exports__